import React from 'react'
import styled from '@emotion/styled'
import { ThemeProvider } from '@emotion/react'
import { colors } from 'ic-snacks'
import { FormattedMessage } from 'react-intl'
import { SUBNAV_WIDTH } from 'legacy/common/theme'
import { NavHeader, NavFooter } from './NavTypography'
import { type LocalNavTheme } from 'legacy/components/Nav/nav.types'

const SubNavElement = styled.div<{ theme?: LocalNavTheme }>`
  width: ${SUBNAV_WIDTH};
  color: ${({ theme }) => (!theme.inverted ? colors.GRAY_13 : colors.WHITE)};
  background-color: ${({ theme }) => (!theme.inverted ? colors.WHITE : colors.GRAY_20)};
  min-height: 100%;
  display: flex;
  flex-direction: column;
`

interface Props {
  title?: string
  inverted?: boolean
  style?: React.CSSProperties
  footer?: React.ReactNode | string
  children?: React.ReactNode
}

const SubNav: React.FunctionComponent<Props> = props => {
  const { children, title, inverted, style, footer, ...rest } = props

  return (
    <ThemeProvider theme={prevTheme => ({ ...prevTheme, inverted })}>
      <SubNavElement style={style} {...rest}>
        {title && (
          <NavHeader>
            <FormattedMessage id={title} />
          </NavHeader>
        )}
        {children}
        {footer && <NavFooter>{footer}</NavFooter>}
      </SubNavElement>
    </ThemeProvider>
  )
}

export default SubNav
